import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ErrorMessage} from "../sara-input/error-message";
import {InputSelectMessages} from "./input-select-messages";

@Component({
    selector: 'sara-select',
    templateUrl: './sara-select.component.html',
})
export class SaraSelectComponent {

    @Input() error:ErrorMessage;
    @Input() name:string;
    @Input() default:any;
    @Input() messages:InputSelectMessages;
    @Input() required:boolean;
    @Input() disabled:boolean;


    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    modelValue: any;

    @Input()
    get model() {
        return this.modelValue;
    }

    set model(val) {
        this.updateValidation();
        this.modelValue = val;
        this.modelChange.emit(this.modelValue);
    }
    constructor(){
        this.default = {
            active: false,
            text: ''
        }
    }

    updateValidation = function () {
        if(this.error){
            this.error = null;
        }
    }

    isNumber(val) {
        return typeof val === 'number';
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/shared/sara-select/sara-select.component.ts